import { Box, Typography } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import cskImg from '../../images/instant1.png';
import rcbImg from '../../images/instant2.png';
import lsgImg from '../../images/instant3.png';
import delhiImg from '../../images/instant4.png';
import gtImg from '../../images/instant5.png';
import miImg from '../../images/instant6.png';
import kkrImg from '../../images/instant7.png';
import srhImg from '../../images/instant8.png';
import rrImg from '../../images/instant9.png';
import pbksImg from '../../images/instant10.png';

import BetSlip from './betslip.jsx';
import GameVideo from './GameVideo.js';

const TEAMS = [
  { name: "CSK", img: cskImg, odds: 9 },
  { name: "RCB", img: rcbImg, odds: 9 },
  { name: "LSG", img: lsgImg, odds: 9 },
  { name: "Delhi", img: delhiImg, odds: 9 },
  { name: "Team GT", img: gtImg, odds: 9 },
  { name: "MI", img: miImg, odds: 9 },
  { name: "KKR", img: kkrImg, odds: 9 },
  { name: "SRH", img: srhImg, odds: 9 },
  { name: "RR", img: rrImg, odds: 9 },
  { name: "PBKS", img: pbksImg, odds: 9 },
];

// const GAME_OPTIONS = [
//   "Instant Game",
// ];

const PILL_LABELS = [
  "CSK", "RCB", "LSG", "DELHI", "GT",
  "MI", "KKR", "SRH", "RR", "PBKS"
];

const th = {
  padding: '10px 8px',
  textAlign: 'left',
  fontWeight: '600',
  fontSize: '13px',
  whiteSpace: 'nowrap',
  color: '#fff',
  background: '#001F3F',
  borderRight: '0.5px solid #E8E8E8',
  height: '26px'
};

const td = {
  padding: '4px 8px',
  fontWeight: '400',
  fontSize: '12px',
  color: '#3A3A3A',
  borderBottom: 'none',
  borderRight: '0.5px solid #E8E8E8',
  height: '32px'
};

function LockIcon({ color = "white" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 20" fill="none">
      <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill={color} />
    </svg>
  );
}

function UserAvatarIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" fill="#001F3F" />
      <path
        d="M4 20c0-4 3.6-7 8-7s8 3 8 7"
        stroke="#001F3F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function GameDropdown({ selected, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  return (
    <Box className={styles.gameSelectWrapper} ref={wrapperRef}>
      

      {/* {isOpen && (
        <Box className={styles.dropdownMenu}>
          {GAME_OPTIONS.map((opt) => (
            <Box
              key={opt}
              className={`${styles.dropdownItem} ${
                opt === selected ? styles.dropdownItemSelected : ''
              }`}
              onClick={() => {
                onSelect(opt);
                setIsOpen(false);
              }}
            >
              <Typography className={styles.dropdownItemText}>
                {opt}
              </Typography>
            </Box>
          ))}
        </Box>
      )} */}
    </Box>
  );
}

function TeamRow({ team, locked, onTeamClick }) {
  const [imgError, setImgError] = useState(false);

  return (
    <Box className={styles.RowBox}>
      <Box className={styles.InnerBox}>
        <Box className={styles.teamAvatar}>
          {imgError ? (
            <Typography className={styles.avatarFallback}>
              {team.name.charAt(0)}
            </Typography>
          ) : (
            <img
              src={team.img}
              alt={team.name}
              onError={() => setImgError(true)}
              className={styles.avatarImg}
            />
          )}
        </Box>

        <Typography className={styles.RowText}>
          {team.name}
        </Typography>
      </Box>

      <Box
        className={styles.BlueButton}
        onClick={() => onTeamClick(team)}
        sx={{
          cursor: locked ? 'not-allowed' : 'pointer',
          position: 'relative'
        }}
      >
        <Typography className={styles.NumberText}>
          {team.odds}
        </Typography>

        {locked && (
          <Box className={styles.bettinglocked_icon_container}>
            <LockIcon />
          </Box>
        )}
      </Box>

      <Box
        className={styles.RedButton}
        sx={{
          cursor: 'not-allowed',
          position: 'relative'
        }}
      >
        <Box className={styles.bettinglocked_icon_container}>
          <LockIcon />
        </Box>
      </Box>
    </Box>
  );
}

function InstantGame({
  onBetSelect,
  locked,
  socketData,
  settledData,
}) {
 

     
  const [selectedGame, setSelectedGame] = useState("Instant Game");
  const [activeTab, setActiveTab] = useState("GAME");

  const [openBetSlip, setOpenBetSlip] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);

  const [betsData, setBetsData] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleTeamClick = (team) => {
    if (!locked) {
      const betData = {
        label: team.name,
        odds: team.odds,
        roundId: socketData?.roundId || 0,
        stake: 100,
      };

      if (onBetSelect) {
        onBetSelect(betData);
      }

      setSelectedTeam(team);
      setOpenBetSlip(true);

      window.scrollTo({ top: 0, behavior: "instant" });
    }
  };

  const timerValue = socketData?.remainingTime ;

  const timerDigits = String(timerValue)
    .padStart(2, '0')
    .split('');

  return (
    <Box className={styles.MatchScreen_container}>

    

      {/* ── Tabs ── */}
      {/* <Box className={styles.tabsRow}>
  
        <Box
          className={`${styles.tab} ${
            activeTab === 'BETS' ? styles.tabActive : ''
          }`}
          onClick={() => setActiveTab('BETS')}
        >
          <Typography className={styles.tabText}>
            MY BETS
            <span className={styles.betsCount}>
              ({betsData.length})
            </span>
          </Typography>
        </Box>

        
      </Box> */}

      {/* ── GAME Tab ── */}
      {activeTab === 'GAME' && (
        <Box className={styles.videoArea}>

   <GameVideo socketData={socketData} />

          {/* Timer on top of video */}
          <Box className={styles.timerBlock}>
            {timerDigits.map((digit, i) => (
              <Box key={i} className={styles.timerDigit}>
                <Typography className={styles.timerDigitText}>
                  {digit}
                </Typography>
              </Box>
            ))}
          </Box>

        </Box>
      )}

      {/* ── Teams List ── */}
      {activeTab === 'GAME' && (
        <Box className={styles.box1}>
          <Box className={styles.box2}>
            {TEAMS.map((team) => (
              <TeamRow
                key={team.name}
                team={team}
                locked={locked}
                onTeamClick={handleTeamClick}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* ── MY BETS Tab ── */}
      {activeTab === 'BETS' && (
        <Box sx={{ width: '100%', overflowX: 'auto', mt: 1 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', fontFamily: 'Poppins, sans-serif' }}>
            <thead>
              <tr style={{ background: '#001F3F', color: '#fff' }}>
                <th style={th}>No</th>
                <th style={th}>Runner Name</th>
                <th style={th}>Round ID</th>
                <th style={th}>Odds</th>
                <th style={th}>Stakes</th>
                <th style={th}>Win</th>
                <th style={th}>Status</th>
                <th style={th}>Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {betsData.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                    No bets placed yet
                  </td>
                </tr>
              ) : (
                betsData.map((bet, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#FAC9D1' : '#A6D8FF', borderBottom: '0.5px solid #E8E8E8' }}>
                    <td style={td}>{i + 1}</td>
                    <td style={td}>{bet.runnerName}</td>
                    <td style={td}>{bet.roundId}</td>
                    <td style={td}>{bet.odds}</td>
                    <td style={td}>{bet.stakes}</td>
                    <td style={td}>{bet.win}</td>
                    <td style={td}>{bet.status}</td>
                    <td style={td}>{bet.dateTime}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Box>
      )}

      {/* ── Footer ── */}
      {activeTab === 'GAME' && (
        <Box className={styles.footerBar}>
          <Typography className={styles.lastResult}>
            Last Result |
            <span className={styles.viewAll}>
              View All
            </span>
          </Typography>

          <Typography className={styles.playerHistory}>
            Player History
          </Typography>
        </Box>
      )}

      {/* ── Pills ── */}
      {activeTab === 'GAME' && (
        <Box className={styles.teamPills}>
          {PILL_LABELS.map((label) => (
            <Box key={label} className={styles.pill}>
              <Typography className={styles.pillText}>
                {label}
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {/* ── Bet Slip Popup ── */}
      {activeTab === 'GAME' && openBetSlip && selectedTeam && (
        <Box
          sx={{
            position: "fixed",
            left: 0,
            right: 0,
            top: 410,
            zIndex: 9999,
            padding: "12px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "500px",
            }}
          >
            <BetSlip
              team={selectedTeam}
              onCancel={() => {
                setOpenBetSlip(false);
                setSelectedTeam(null);
              }}
              onSubmit={(data) => {
                setBetsData((prev) => [...prev, {
                  runnerName: data.team.name,
                  roundId: socketData?.roundId || '123456789',
                  odds: data.odds,
                  stakes: data.stake,
                  win: '-',
                  status: 1,
                  dateTime: new Date().toLocaleString('en-IN'),
                }]);
                setOpenBetSlip(false);
                setSelectedTeam(null);
              }}
            />
          </Box>
        </Box>
      )}

    </Box>
  );
}

export default InstantGame;